const facilities = [
  {
    name: "Johnson City Main Post Office",
    type: "USPS Acceptance Facility",
    address: "200 W Market St, Johnson City, TN 37604",
    hours: "Mon–Fri 8:30 AM – 5:00 PM",
    phone: "(423) 926-3481",
    notes: "Full passport acceptance services. Appointments strongly recommended. Located in downtown Johnson City near the ETSU campus.",
    icon: "ri-mail-line",
    featured: true,
  },
  {
    name: "Jonesborough Post Office",
    type: "USPS Acceptance Facility",
    address: "106 E Main St, Jonesborough, TN 37659",
    hours: "Mon–Fri 9:00 AM – 4:30 PM",
    phone: "(423) 753-6420",
    notes: "Passport acceptance by appointment. Washington County seat office with passport photos available nearby.",
    icon: "ri-mail-line",
    featured: false,
  },
  {
    name: "Elizabethton Post Office",
    type: "USPS Acceptance Facility",
    address: "415 S Sycamore St, Elizabethton, TN 37643",
    hours: "Mon–Fri 9:00 AM – 4:00 PM",
    phone: "(423) 542-1181",
    notes: "Passport acceptance for Carter County residents. Convenient for Elizabethton, Hampton, and Roan Mountain travelers.",
    icon: "ri-mail-line",
    featured: false,
  },
  {
    name: "Johnson City Federal Building",
    type: "Federal Acceptance",
    address: "220 W Market St, Johnson City, TN 37604",
    hours: "Mon–Fri 8:00 AM – 4:30 PM",
    phone: "(423) 929-8000",
    notes: "Government facility offering passport acceptance services. Photo services available nearby at downtown locations.",
    icon: "ri-government-line",
    featured: false,
  },
  {
    name: "Unicoi County Post Office",
    type: "USPS Acceptance Facility",
    address: "104 Nolichucky Ave, Erwin, TN 37650",
    hours: "Mon–Fri 9:00 AM – 4:00 PM",
    phone: "(423) 743-4157",
    notes: "Passport acceptance for Unicoi County and Erwin residents. Convenient for Nolichucky River corridor travelers.",
    icon: "ri-mail-line",
    featured: false,
  },
];

export default function JohnsonCityAcceptanceFacilitiesSection() {
  return (
    <section id="facilities" className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Local Facilities</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Passport Acceptance Facilities in Johnson City
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            These local facilities handle in-person acceptance for first-time applications and minors. For renewals, we handle everything by mail without a facility visit.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-10">
          {facilities.map((f, i) => (
            <div key={i} className={`rounded-xl p-7 border ${f.featured ? "border-[#F6C344] bg-[#F6C344]/5" : "border-gray-200 bg-white"} flex flex-col`}>
              {f.featured && (
                <span className="inline-block bg-[#F6C344] text-[#1A365D] text-xs font-bold px-3 py-1 rounded-full mb-4 self-start">Primary Location</span>
              )}
              <div className="flex items-start gap-3 mb-4">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#EEF2F8] flex-shrink-0">
                  <i className={`${f.icon} text-[#1A365D] text-lg`}></i>
                </div>
                <div>
                  <h3 className="font-semibold text-[#1A365D] text-base">{f.name}</h3>
                  <span className="text-xs text-gray-400">{f.type}</span>
                </div>
              </div>
              <div className="space-y-2 text-sm text-gray-500 mb-4 flex-1">
                <div className="flex items-start gap-2">
                  <i className="ri-map-pin-line text-[#1A365D] mt-0.5 flex-shrink-0"></i>
                  <span>{f.address}</span>
                </div>
                <div className="flex items-center gap-2">
                  <i className="ri-time-line text-[#1A365D] flex-shrink-0"></i>
                  <span>{f.hours}</span>
                </div>
                <div className="flex items-center gap-2">
                  <i className="ri-phone-line text-[#1A365D] flex-shrink-0"></i>
                  <span>{f.phone}</span>
                </div>
              </div>
              <p className="text-xs text-gray-400 leading-relaxed border-t border-gray-100 pt-4">{f.notes}</p>
            </div>
          ))}
        </div>

        <div className="bg-[#1A365D] rounded-xl p-8 text-center">
          <h3 className="font-serif text-2xl font-bold text-white mb-3">Don&apos;t Want to Visit a Facility?</h3>
          <p className="text-white/70 text-sm max-w-xl mx-auto leading-relaxed mb-6">
            Adult renewals don&apos;t require an in-person visit. We handle everything by mail — from document review to submission and return shipping. Johnson City residents with valid prior passports can renew entirely from home.
          </p>
          <a href="https://fastpassportcenter.com/checkout/" className="inline-flex items-center gap-2 bg-[#F6C344] text-[#1A365D] font-semibold px-8 py-3 rounded-lg hover:bg-[#e5b33f] transition-all whitespace-nowrap">
            Start Mail-In Renewal
          </a>
        </div>
      </div>
    </section>
  );
}